import React from 'react';
import { Typography, Divider } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { Stack, List } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../../../utils/dateFormatter';
import AppointmentsListItems from '../lists/AppointmentsListItems';

export default function DateAppointmentsView({open, onClose, date}) { 
    const { t } = useTranslation('common'); 
    const handleClose = () => {
        onClose();
        setListEmpty(true);
        setDoneLoading(false);
        setMessage('fetching data...');
    };
    const [listEmpty, setListEmpty] = React.useState(true);
    const [doneLoading, setDoneLoading] = React.useState(false);
    const [message, setMessage] = React.useState('fetching data...');

    React.useEffect(() => {
      if (open && doneLoading && listEmpty)
      {
        if (listEmpty) setMessage('no appointments');
      }
    }, [doneLoading, open, listEmpty]);

    return (
        <React.Fragment>
        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            
            <DialogTitle>
              <Stack spacing={2}>
                <>
                <Typography variant="h6" sx={{margin: 0, lineHeight: 1}}>Appointments</Typography>
                <Typography variant="h5" sx={{margin: 0, lineHeight: 0}}>{formatDate(date)}</Typography>
                </>
              </Stack>
            </DialogTitle>
            <DialogContent dividers>
              {listEmpty ? 
              <Divider variant="fullWidth" component="li" sx={{ border: "none" }}>
                <Typography variant="caption" color="text.secondary">
                  {message}
                </Typography>
              </Divider>
              : null }
              <List >
                <AppointmentsListItems
                  date={date}
                  mode="calendar"
                  setListEmpty={setListEmpty}
                  setDoneLoading={setDoneLoading}
                />
              </List>
            </DialogContent>
            <DialogActions>
              <div style={{flex: '1 0 0'}} />
              <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
        </React.Fragment>
    );
}